import { render, staticRenderFns } from "./Invoices.vue?vue&type=template&id=c886ad48&scoped=true"
import script from "./Invoices.vue?vue&type=script&lang=js"
export * from "./Invoices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c886ad48",
  null
  
)

export default component.exports